<script>
	const Q = require('q');
	const _ = require('underscore');
	const page = require('page');

	const metadata = require('core/metadata');
	const model = require('model/model');
	const utilities = require('utilities');

	const skiUtilities = require('utilities/studentKnowledgeInventoryUtilities');
	const studentGetReadingMindsetSnapshotWorkspace = skiUtilities.studentGetReadingMindsetSnapshotWorkspace;

	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const searchLibrary = studentLibraryUtilities.searchLibrary;
	const getReadingList = studentLibraryUtilities.getReadingList;
	const getFavorites = studentLibraryUtilities.getFavorites;
	const studentGetArticlesRead = studentLibraryUtilities.studentGetArticlesRead;
	const getStudentSettings = studentLibraryUtilities.getStudentSettings;
	const addReadingList = studentLibraryUtilities.addReadingList;
	const removeReadingList = studentLibraryUtilities.removeReadingList;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_PREVIEW_EXIT = analyticsUtilities.events.SL_PREVIEW_EXIT;
	const SL_TOOL_CLICK = analyticsUtilities.events.SL_TOOL_CLICK;
	const SL_SEARCH_UI = analyticsUtilities.events.SL_SEARCH_UI;
	const SL_SEARCH = analyticsUtilities.events.SL_SEARCH;
	const SL_LIST = analyticsUtilities.events.SL_LIST;
	const SL_LOG = analyticsUtilities.events.SL_LOG;
	const SL_HOME = analyticsUtilities.events.SL_HOME;
	const SL_BOOKMARK = analyticsUtilities.events.SL_BOOKMARK;

	const navMap = {
		home: {
			name: 'Library Home',
			component: 'library-home'
		},
		'read-next': {
			name: 'Reading List',
			component: 'library-read-next'
		},
		'reading-log': {
			name: 'Reading Log',
			component: 'library-reading-log'
		},
		content: {
			name: 'Product View',
			component: 'library-content'
		},
		ebook: {
			name: 'Product View',
			component: 'library-content'
		},
		'search-results': {
			name: 'Search Results',
			component: 'library-search-results'
		}
	};

	module.exports = {
		components: {
			'library-home': require('components/routes/student-library/library-home.vue').default,
			'library-search-results': require('components/routes/student-library/library-search-results.vue').default,
			'library-read-next': require('components/routes/student-library/library-read-next.vue').default,
			'library-reading-log': require('components/routes/student-library/library-reading-log.vue').default,
			'library-content': require('components/routes/student-library/library-content.vue').default,
			'library-settings': require('components/routes/student-library/library-settings.vue').default,
			'search-bar-with-suggestions': require('components/search-bar-with-suggestions.vue').default,
			'heart-icon': require('components/svg/heart-icon.vue').default,
			'bookmark-icon': require('components/svg/bookmark-icon.vue').default,
			'library-home-icon': require('components/svg/library-home-icon.vue').default,
			'checkbox-icon': require('components/svg/checkbox-icon.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'input-item-with-label': require('components/input-item-with-label.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		modelData: [
			'userContext',
			'libraryView',
			'productId',
			'libraryResults',
			'q',
			't',
			'features',
			'studentLibrarySettings',
			'activeClass',
			'activeProduct'
		],
		data() {
			return {
				metadata,
				navMap,
				showSearchBar: false,
				viewLog: [],
				loading: false,
				f: 0,
				tts: false,
				teacherClassCode: null,
				internalLoading: false
			};
		},
		computed: {
			theme() {
				let studentLibrarySettings = this.studentLibrarySettings;
				let t = '';
				if (studentLibrarySettings && studentLibrarySettings.t) {
					t = studentLibrarySettings.t;
				}
				return t;
			},
			previousPage() {
				let viewLog = this.viewLog;
				let view = 'home';
				if (viewLog && viewLog.length > 1) {
					view = viewLog[viewLog.length - 2];
				}
				return view;
			},
			textTypes() {
				let textTypeSelections = this.t || [];
				let ttSelMap = textTypeSelections.reduce((acc, tid) => {
					acc[tid] = true;
					return acc;
				}, {});
				let data = metadata.textTypes;

				return data.map(tt => {
					return _.assign({}, tt, {
						selected: ttSelMap[tt.id]
					});
				});
			},
			featuresList() {
				let featureSelections = this.features || [];
				let featureMap = featureSelections.reduce((acc, feature) => {
					acc[feature] = true;
					return acc;
				}, {});
				let data = [
					{
						id: 'ebook',
						text: 'eBooks'
					}
				];

				return data.map(f => {
					return _.assign({}, f, {
						selected: featureMap[f.id]
					});
				});
			},
			isTeacher() {
				return this.userContext && !this.userContext.classCode;
			},
			grade() {
				let activeClass = this.activeClass;
				let g = activeClass ? activeClass.g || activeClass.grade : null;
				return g;
			},
			navItem() {
				let libraryView = this.libraryView;
				let item = navMap[libraryView] || navMap.home;

				return item;
			}
		},
		watch: {
			showSearchBar(val) {
				fireEvent(SL_SEARCH_UI, {
					open: val,
					loc: this.libraryView
				});
			},
			libraryView(val) {
				let view = val === 'ebook' ? 'content' : val;
				if (view) {
					if (this.viewLog.length === 0 || view !== this.viewLog[this.viewLog.length - 1]) {
						this.viewLog.push(view);
					}
				} else {
					model.set('libraryView', 'home');
				}

				if (view !== 'content' && view !== 'ebook') {
					model.remove('productId');
				} else if (!model.get('productId')) {
					model.set('libraryView', 'home');
				}
			},
			productId(val) {
				let libraryView = this.libraryView;
				if (val && libraryView !== 'content' && libraryView !== 'ebook') {
					model.set('libraryView', 'content');
				}
			},
			t(val, oldVal) {
				let valStr = JSON.stringify(val);
				let oldValStr = JSON.stringify(oldVal);
				if (val instanceof Array && oldVal !== null && valStr !== oldValStr) {
					this.onSearchSubmit(this.q, val, this.features);
				}
			},
			features(val, oldVal) {
				let valStr = JSON.stringify(val);
				let oldValStr = JSON.stringify(oldVal);
				if (val instanceof Array && oldVal !== null && valStr !== oldValStr) {
					this.onSearchSubmit(this.q, this.t, val);
				}
			}
		},
		methods: {
			suggestionCategoryFormatter(obj) {
				let category = obj.parentName;
				if (category === 'Domain') {
					category = 'Topic';
				}
				return category;
			},
			onSearchToolbarButtonClick() {
				let libraryView = this.libraryView;
				if (libraryView === 'search-results') {
					model.remove('q');
					model.remove('t');
					model.remove('features');
					model.remove('libraryResults');

					this.f = 0;
					this.goBack();
				}
				this.showSearchBar = !this.showSearchBar;
			},
			onSearchInput(val) {
				model.set('q', val);
			},
			onSearchSubmit(q, t, features) {
				q = q || model.get('q') || void 0;
				t = t || model.get('t') || void 0;
				features = features || model.get('features') || void 0;
				let grade = this.grade;

				$(':focus').blur();
				this.loading = true;
				fireEvent(SL_SEARCH, {
					q,
					t
				});

				model.set('libraryView', 'search-results');
				searchLibrary(0, q, t, grade, features).finally(() => (this.loading = false));
			},
			getMoreResults() {
				let q = model.get('q') || void 0;
				let t = model.get('t') || void 0;
				let features = model.get('features') || void 0;
				let grade = this.grade;

				this.f += 1;
				this.loading = true;
				searchLibrary(this.f, q, t, grade, features).finally(() => (this.loading = false));
			},
			goBack() {
				let view = 'home';
				let currentView = this.libraryView;
				let eventMap = {
					home: SL_HOME,
					'read-next': SL_LIST,
					'reading-log': SL_LOG
				};

				if (this.viewLog && this.viewLog.length > 1) {
					this.viewLog.pop();
					view = this.viewLog.pop();
				}

				let eventName = eventMap[view];

				if (eventName && currentView !== 'search-results') {
					fireEvent(eventName, {
						loc: 'back'
					});
				}

				model.set('libraryView', view);
			},
			onTextTypeSelect(tt) {
				let textTypeSelections = this.t || [];
				if (textTypeSelections.indexOf(tt.id) === -1) {
					textTypeSelections = [...textTypeSelections, tt.id];
				} else {
					textTypeSelections = textTypeSelections.filter(tid => tid !== tt.id);
				}
				this.t = textTypeSelections;
			},
			onFeatureSelect(f) {
				let featureSelections = this.features || [];
				if (featureSelections.indexOf(f.id) === -1) {
					featureSelections = [...featureSelections, f.id];
				} else {
					featureSelections = featureSelections.filter(tid => tid !== f.id);
				}
				this.features = featureSelections;
			},
			openSettingsModal(initial) {
				utilities.openModal('#modal-library-settings', {
					initial
				});
			},
			exitPreviewClick() {
				let cc = this.activeClass ? this.activeClass.classCode : null;
				if (cc) {
					fireEvent(SL_PREVIEW_EXIT, {
						cc
					});
				}
				model.remove('activeClass');
			},
			onTTSClick() {
				this.tts = !this.tts;
				fireEvent(SL_TOOL_CLICK, {
					action_type: 'show_tts',
					value: this.tts
				});
			},
			onNavClick(e) {
				let view = null;
				if (e && e.target) {
					view = e.target.getAttribute('data-tab');
				}
				let eventMap = {
					home: SL_HOME,
					'read-next': SL_LIST,
					'reading-log': SL_LOG
				};
				let eventName = eventMap[view];
				if (eventName) {
					fireEvent(eventName, {
						loc: 'nav'
					});
				}
			},
			addToReadingList() {
				let activeProduct = this.activeProduct;
				let libraryView = this.libraryView;

				if (activeProduct && activeProduct.uuid) {
					let p = activeProduct.uuid;
					this.internalLoading = true;
					fireEvent(SL_BOOKMARK, {
						pid: p,
						value: true,
						loc: libraryView
					});
					addReadingList(p).finally(() => (this.internalLoading = false));
				}
			},
			removeFromReadingList() {
				let activeProduct = this.activeProduct;
				let libraryView = this.libraryView;

				if (activeProduct && activeProduct.uuid) {
					let p = activeProduct.uuid;
					this.internalLoading = true;
					fireEvent(SL_BOOKMARK, {
						pid: p,
						value: false,
						loc: libraryView
					});
					removeReadingList(p).finally(() => (this.internalLoading = false));
				}
			}
		},
		mounted() {
			const libraryView = this.libraryView;
			const q = model.get('q');
			const tt = model.get('t');
			const features = model.get('features');
			const isTeacher = this.isTeacher;
			const activeClass = this.activeClass;
			const getRMSWorkspace = isTeacher ? () => Promise.resolve() : studentGetReadingMindsetSnapshotWorkspace;

			model.remove('studentOffset');
			model.remove('studentTab');

			this.loading = true;
			if (!activeClass) {
				if (isTeacher) {
					page('/class-admin#!classAdmin:roster/');
				} else {
					page('/student-authentication');
				}
			} else if (isTeacher) {
				this.teacherClassCode = activeClass.classCode;
			}
			Q.all([getFavorites(), getReadingList(), studentGetArticlesRead(), getStudentSettings(), getRMSWorkspace()])
				.then(() => {
					let librarySettings = model.get('studentLibrarySettings');
					let ws = model.get('rmsWorkspace');

					if (this.isTeacher) {
						let skf = metadata.skf.reduce((acc, s) => {
							acc[s.rms_key] = true;
							return acc;
						}, {});
						model.set('studentLibrarySettings', {
							t: 'space',
							g: {},
							skf
						});
					} else if (!librarySettings || librarySettings.u < ws.u) {
						let t = 'space';
						let g = {};
						let skf = {};

						// Auto fill settings from SKI if not present
						if (ws && ws.sc) {
							if (ws.sc[19] && ws.sc[19].length) {
								g = ws.sc[19].reduce((acc, i) => {
									acc[i] = true;
									return acc;
								}, {});
							}
							for (let i = 7; i <= 18; i++) {
								let answer = ws.sc[i];
								if (answer === 0) {
									skf[i] = true;
								}
							}
							model.set('studentLibrarySettings', {
								t,
								g,
								skf
							});
						}
						this.openSettingsModal(true);
					}
				})
				.finally(() => (this.loading = false));

			if ((q || tt || features) && libraryView === 'search-results') {
				this.onSearchSubmit(q, tt, features);
				this.showSearchBar = true;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	@font-face {
		font-family: 'Roboto Slab';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src:
			local('Roboto Slab Regular'),
			local('RobotoSlab-Regular'),
			url(https://fonts.gstatic.com/s/robotoslab/v9/BngMUXZYTXPIvIBgJJSb6ufN5qWr4xCC.woff2) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
			U+2215, U+FEFF, U+FFFD;
	}

	@font-face {
		font-family: 'Arvo';
		font-style: normal;
		font-weight: 400;
		src:
			local('Arvo'),
			url(https://fonts.gstatic.com/s/arvo/v13/tDbD2oWUg0MKqScQ7Z7o_vo.woff2) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
			U+2215, U+FEFF, U+FFFD;
	}

	@font-face {
		font-family: 'Titillium Web';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src:
			local('Titillium Web Regular'),
			local('TitilliumWeb-Regular'),
			url(https://fonts.gstatic.com/s/titilliumweb/v8/NaPecZTIAOhVxoMyOr9n_E7fdMPmDaZRbrw.woff2) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
			U+2215, U+FEFF, U+FFFD;
	}

	.student-library {
		.preview-exit-link {
			position: absolute;
			top: 0;
			padding: 1rem;
			background-color: $c-blue-notif;
			border-color: $c-dark-teal;
			border-width: 0 1px 1px 1px;
			border-style: solid;
			border-radius: 0 0 7px 7px;
		}

		.toolbar-inner,
		.banner-inner,
		.reading-list-inner {
			margin: 0 2rem;
		}

		.banner {
			background-color: $c-blue-dark;
			background-repeat: no-repeat;
			background-position-x: right;
			background-size: contain;

			.banner-inner {
				position: relative;
				display: flex;
				align-items: center;
				min-height: 7rem;
				padding: 0rem 1rem;
				transition: all 0.5s;
			}

			h1 {
				color: $c-white;
			}
		}

		&.content,
		&.ebook {
			.banner {
				.banner-inner {
					min-height: 7rem;

					h1 {
						display: none;
					}
				}
			}
		}

		&.search-results {
			.banner {
				.banner-inner {
					h1 {
						display: none;
					}
				}
			}
		}

		.toolbar {
			border-width: 1px 0;
			border-color: $c-grey;
			border-style: solid;

			.toolbar-inner {
				display: flex;
				flex-wrap: wrap;

				&.product {
					padding: 1rem 0;
				}

				.notifications,
				.search-bar {
					flex: 1;
					border-right: 1px solid $c-grey;
				}

				.notifications {
					white-space: normal;

					svg {
						fill: none;
						margin-top: -6px;
						margin-right: 0.25rem;
						stroke: $c-slate-dark;
						stroke-width: 2px;

						&:hover {
							stroke: $c-blue;
						}
					}
				}

				.search-bar {
					display: flex;
					align-items: center;

					i.fa-magnifying-glass,
					.search-bar-with-suggestions {
						display: inline-block;
					}

					i.fa-magnifying-glass {
						cursor: pointer;

						&:hover {
							color: $c-blue;
						}
					}

					.search-bar-with-suggestions {
						position: relative;
						flex: 1;

						input {
							border-radius: 0;
							border-width: 0;
							background-color: $c-blue-lighter;
						}
					}
				}

				.nav-button {
					position: relative;
					display: inline-block;
					padding: 1rem 0;
					border-bottom: none;
					margin: 0 2rem 0 0;
					text-align: left;
					line-height: inherit;

					&:hover,
					&.active {
						color: $c-blue;

						svg {
							stroke: $c-blue;
						}
					}
				}

				.toolbar-button {
					flex-basis: 3.5rem;
					text-align: center;
					cursor: pointer;

					&:hover {
						background-color: $c-blue;
						color: $c-white;
					}
				}

				.toolbar-button {
					padding: 1rem 0;
					border-right: 1px solid $c-grey;
				}

				.back-link {
					display: flex;
					align-items: center;

					i {
						margin-right: 0.5rem;
					}
				}

				.content-toolbar {
					flex: 1;
					display: flex;
					justify-content: flex-end;
					align-items: center;
					margin-top: 0.5rem;

					.reading-list-text {
						margin: 0 0.5rem 0 0;
					}

					.reading-list-button {
						margin-right: 1rem;
						padding: 0.25rem 1rem;
					}
				}
			}
		}

		.library-body {
		}

		.search-filters {
			background-color: $c-blue-dark;
			color: $c-white;

			.search-filters-inner {
				padding: 2rem;

				.filter-title {
					text-transform: uppercase;
					color: $c-blue-light;
					font-weight: bold;
				}

				.item-label {
					color: $c-white;
				}

				input.input-checkbox[type='checkbox'] {
					background-color: $c-white;
					border-color: $c-grey;
					border-radius: 0;

					&:checked {
						background-color: $c-white;
						border-color: $c-grey;

						&:after {
							content: '\2713';
						}
					}
				}
			}
		}

		&.space {
			h1,
			h2,
			h3,
			.nav-button {
				font-family: 'Titillium Web';
			}

			.banner {
				background-color: $c-space-main;
				color: $c-white;
			}
		}

		&.back-to-school {
			h1,
			h2,
			h3,
			.nav-button {
				font-family: 'Arvo';
			}

			.banner {
				background-color: $c-bts-main;
				color: $c-white;

				h1 {
					color: $c-slate-dark;
				}
			}
		}

		&.global {
			h1,
			h2,
			h3,
			.nav-button {
				font-family: 'Merriweather';
			}

			.banner {
				background-color: $c-global-main;
				color: $c-white;

				h1 {
					color: $c-slate-dark;
				}
			}
		}

		&.flow {
			h1,
			h2,
			h3,
			.nav-button {
				font-family: 'Roboto Slab';
			}

			.banner {
				background-color: $c-flow-main;
				color: $c-white;

				h1 {
					color: $c-white;
				}
			}
		}

		&.green {
			h1,
			h2,
			h3,
			.nav-button {
				font-family: 'Helvetica Neue';
			}

			.banner {
				background-color: $c-green-main;
				color: $c-white;

				h1 {
					color: $c-white;
				}
			}
		}

		&.grape {
			h1,
			h2,
			h3,
			.nav-button {
				font-family: 'Helvetica Neue';
			}

			.banner {
				background-color: $c-grape-main;
				color: $c-white;

				h1 {
					color: $c-white;
				}
			}
		}

		h1,
		h2,
		h3 {
			font-family: 'Helvetica Neue';
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.student-library .toolbar .toolbar-inner .content-toolbar {
			margin-top: 0;
		}
	}
</style>
<template>
	<main
		id="content"
		:class="['student-library', theme, libraryView]">
		<div class="banner">
			<div class="banner-inner wrapper">
				<a
					:href="`/class-admin#!classAdmin:roster/rosterView:library/classCode:${teacherClassCode}/`"
					class="preview-exit-link"
					@click="exitPreviewClick"
					v-if="isTeacher && activeClass">
					&larr; Exit Library Preview
				</a>
				<h1 v-if="libraryView === 'home'">Welcome to {{ userContext.firstName }}'s Library!</h1>
				<h1 v-if="libraryView !== 'home' && navItem">{{ userContext.firstName }}'s {{ navItem.name }}</h1>
			</div>
		</div>
		<div class="toolbar">
			<div
				class="toolbar-inner browsing wrapper"
				v-if="!productId">
				<tab-container
					class="notifications"
					model-key="libraryView"
					default-tab="home"
					v-if="!showSearchBar">
					<button
						class="home-button nav-button"
						data-tab="home"
						@click="onNavClick">
						<library-home-icon></library-home-icon> Home
					</button>
					<button
						class="reading-list-button nav-button"
						data-tab="read-next"
						:class="{
							active: libraryView === 'read-next'
						}"
						@click="onNavClick">
						<bookmark-icon></bookmark-icon> Reading List
					</button>
					<button
						class="reading-log-button nav-button"
						data-tab="reading-log"
						:class="{
							active: libraryView === 'reading-log'
						}"
						@click="onNavClick">
						<checkbox-icon></checkbox-icon> Reading Log
					</button>
				</tab-container>
				<form
					class="search-bar"
					v-if="showSearchBar"
					@submit.prevent="onSearchSubmit(q)">
					<i
						class="fa-solid fa-magnifying-glass"
						@click="onSearchSubmit(q)"
						aria-label="Search"></i>
					<search-bar-with-suggestions
						:value="q"
						@input.native="onSearchInput($event.target.value)"
						:category-formatter="suggestionCategoryFormatter"
						placeholder="What are you looking for?"
						maxlength="256">
					</search-bar-with-suggestions>
				</form>
				<button
					class="search-button toolbar-button button -link"
					@click="onSearchToolbarButtonClick"
					aria-label="Toggle search bar">
					<i
						class="fa-solid"
						:class="{
							'fa-magnifying-glass': !showSearchBar,
							'fa-xmark': showSearchBar
						}"
						aria-hidden="true"></i>
				</button>
				<button
					class="tts-button toolbar-button button -link"
					:class="{
						active: tts
					}"
					@click="onTTSClick"
					aria-label="Enable text-to-speech">
					<i
						class="fa-solid fa-volume-high"
						aria-hidden="true"></i>
				</button>
				<button
					class="settings-button toolbar-button button -link"
					@click="openSettingsModal()"
					aria-label="Open settings">
					<i
						class="fa-solid fa-cog"
						aria-hidden="true"></i>
				</button>
			</div>
			<div
				class="toolbar-inner product wrapper"
				v-if="productId">
				<span
					class="back-link link-grey"
					@click="goBack">
					<i
						class="fa-solid fa-chevron-left"
						aria-hidden="true"></i>
					Back to {{ navMap[previousPage].name || navMap['home'].name }}
				</span>
				<div class="content-toolbar">
					<p
						v-if="!isTeacher && !loading && activeProduct && activeProduct.readNext"
						class="reading-list-text text-muted">
						This passage is in your reading list.
					</p>
					<button
						v-if="!isTeacher && !loading && activeProduct && !activeProduct.read"
						@click="activeProduct.readNext ? removeFromReadingList() : addToReadingList()"
						class="button -outline reading-list-button"
						:disabled="!activeProduct || internalLoading || loading"
						:class="{ '-active': activeProduct.readNext }">
						<bookmark-icon></bookmark-icon>
					</button>
					<tab-container
						class="ebook-toggle"
						model-key="libraryView"
						variant="toggle"
						v-if="activeProduct && activeProduct.ebook">
						<button
							class="content-button toggle-button button -small"
							data-tab="content"
							@click="onNavClick">
							Passage
						</button>
						<button
							class="ebook-button toggle-button button -small"
							data-tab="ebook"
							@click="onNavClick">
							eBook
						</button>
					</tab-container>
				</div>
			</div>
		</div>
		<div
			class="search-filters"
			v-show="showSearchBar && !productId">
			<form
				class="search-filters-inner wrapper"
				@submit.prevent>
				<div class="search-filter">
					<div class="filter-title">Include</div>
					<input-item-with-label
						v-for="item in textTypes"
						:key="item.id"
						class="text-type-filter"
						type="checkbox"
						:item="item"
						:on-item-click="onTextTypeSelect">
					</input-item-with-label>
					<input-item-with-label
						v-for="item in featuresList"
						:key="item.id"
						class="feature-filter"
						type="checkbox"
						:item="item"
						:on-item-click="onFeatureSelect">
					</input-item-with-label>
				</div>
			</form>
		</div>
		<div
			class="library-body"
			ref="libraryViewPanel"
			:data-panel="libraryView">
			<component
				v-if="libraryView"
				:is="navItem.component"
				:loading="loading"
				:get-more-results="libraryResults && libraryResults.total > libraryResults.hits.length ? getMoreResults : null"
				:tts="tts"></component>
		</div>
		<library-settings :loading="loading"></library-settings>
	</main>
</template>
